import { SORT_ASC, SORT_DESC } from '@/sortTypes'

export default {
  selection: state => {
    return state.categories.map(category => {
      const selectedNominee = state.selected.find(({ categoryId }) => categoryId === category.id)

      return {
        category,
        nominee: selectedNominee
          ? state.nominees.find(nominee => nominee.id === selectedNominee.nomineeId)
          : null,
        suggestion:
          selectedNominee && typeof selectedNominee.suggestionName !== 'undefined' ? selectedNominee : null
      }
    })
  },

  getNomineesByCategoryId: (state, getters) => categoryIds => {
    return state.nominees
      .filter(({ categoryId }) => categoryId === categoryIds)
      .sort((a, b) => a.name.localeCompare(b.name))
  },

  getFilteredNomineesByCategoryId: (state, getters) => categoryId => {
    const category = state.categories.find(({ id }) => id === categoryId)

    const keyword = category.keyword.trim()

    let filtered = getters.getNomineesByCategoryId(categoryId)
    if (keyword.length) {
      filtered = filtered.filter(({ name }) => name.toLowerCase().indexOf(keyword.toLowerCase()) > -1)
    }

    const { selectedDayPartId, selectedChannelId } = category

    if (typeof selectedDayPartId === 'number') {
      filtered = filtered.filter(({ showtimes }) => {
        return showtimes.some(tag => parseInt(parseInt(Object.keys(tag)[0])) === selectedDayPartId)
      })
    }

    if (typeof selectedChannelId === 'string') {
      filtered = filtered.filter(({ stations }) => {
        return stations.some(tag => tag === selectedChannelId)
      })
    }

    const { sortType } = category

    if (sortType === SORT_ASC) {
      return filtered
    }

    if (sortType === SORT_DESC) {
      return filtered.reverse()
    }

    return filtered.sort((a, b) => 0.5 - Math.random())
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js